import { render, staticRenderFns } from "./CrmProductSlider.vue?vue&type=template&id=2c1f7962"
import script from "./CrmProductSlider.vue?vue&type=script&lang=js"
export * from "./CrmProductSlider.vue?vue&type=script&lang=js"
import style0 from "./CrmProductSlider.vue?vue&type=style&index=0&id=2c1f7962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports